module.exports = __webpack_public_path__ + "img/staff_tmpe.34c60951.png";